/**
 * Display the card brand icon if the input is invalid
 * or the input number belongs to this brand.
 */
export default /* @ngInject */ function showCardIcon(stripeConfig) {
    return function(inputCardBrand, iconCardBrand) {
        return stripeConfig.supportedBrands.indexOf(inputCardBrand) >= 0 ?
            (inputCardBrand === iconCardBrand) : true;
    };
}



// WEBPACK FOOTER //
// ./payments/review/filters/show-card-icon.js